import { PageItemApi } from 'api/PageItemApi';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { QuestionAbstractMapper } from 'mapper/QuestionAbstractMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { QuestionDemographic } from 'model/QuestionDemographic';

export class QuestionDemographicMapper
  implements PageItemKindMapper<QuestionDemographic, PageItemApi.QuestionDemographicEntry>
{
  constructor() {}

  serialize(model: QuestionDemographic): PageItemApi.QuestionDemographicEntry {
    return {
      ...QuestionAbstractMapper.serialize(model),
      options: model.options,
      isGhost: model.isGhost ? 1 : 0,
      required: model.isRequired ? 1 : 0,
      numberingSkipped: model.numberingSkipped ? 1 : 0,
    };
  }

  deserialize(entry: PageItemApi.QuestionDemographicEntry): QuestionDemographic {
    return {
      ...QuestionAbstractMapper.deserializeShape(entry),
      options: (entry.options || []).sort((a, b) => a.position - b.position),
      isGhost: Boolean(entry.isGhost),
      isRequired: Boolean(entry.required),
      numberingSkipped: Boolean(entry.numberingSkipped),
    };
  }

  supportsSerialize(model: PageItemModel): boolean {
    return model.kind === PageItemKind.QuestionDemographic;
  }

  supportsDeserialize(entry: PageItemApi.ItemEntry): boolean {
    return entry.kind === PageItemKind.QuestionDemographic;
  }
}
